<template>
  <div>
    <v-card v-if="!isClinicConcept" class="p-0" rounded="xl">
      <paid-feature-notice :has-permission="hasAdvPermission"/>
      <div style="padding: 20px 30px 0px 30px">
        <div class="d-flex justify-space-between align-center mb-2">
          <h6
            class="text-subtitle-1 font-weight-bold"
            style="height: 40px"
          >
            看診理念
          </h6>
          <v-btn
            v-if="hasAdvPermission"
            color="teal lighten-2"
            class="text-subtitle-2 rounded-lg"
            dark
            style="width: 100px; height: 40px"
            @click="isClinicConcept = true"
          >
            <v-icon dark size="15" class="mr-2">
              mdi-pencil
            </v-icon>
            編輯
          </v-btn>
        </div>
      </div>
      <div style="padding: 0px 30px 20px 30px; position: relative">
        <div
          class="font-weight-bold grey--text text--darken-2 text-pre-line"
          style="min-height: 150px"
          v-text="doctor.principle"
        />
      </div>
    </v-card>
    <clinic-concept-form
      v-if="isClinicConcept"
      :show.sync="isClinicConcept"
      :doctor="doctor"
      @update="onUpdate"
    />
  </div>
</template>

<script>
import PaidFeatureNotice from "@/components/settings/doctor/v2/PaidFeatureNotice.vue";
import ClinicConceptForm from "@/components/settings/doctor/v2/ClinicConceptForm.vue";

export default {
  name: "DoctorConceptSection",

  components: { PaidFeatureNotice, ClinicConceptForm },

  props: {
    doctor: {
      type: Object,
      required: true,
    },
    hasAdvPermission: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isClinicConcept: false,
    };
  },

  methods: {
    onUpdate(payload) {
      this.$emit("update-principle", payload);
    },
  },
};
</script>
